import { MEDIA_MESSAGES } from '../constants/error-messages';
import { isMediaError } from './is-media-error';
export function getErrorFromMediaError(mediaError: MediaError | Error) {
  if (!isMediaError(mediaError)) {
    return mediaError;
  }
  switch (mediaError.code) {
    case MediaError.MEDIA_ERR_ABORTED:
      return new Error(MEDIA_MESSAGES.MEDIA_ERR_ABORTED);
    case MediaError.MEDIA_ERR_NETWORK:
      return new Error(MEDIA_MESSAGES.MEDIA_ERR_NETWORK);
    case MediaError.MEDIA_ERR_DECODE:
      return new Error(MEDIA_MESSAGES.MEDIA_ERR_DECODE);
    case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
      return new Error(MEDIA_MESSAGES.MEDIA_ERR_SRC_NOT_SUPPORTED);
    default:
      return new Error(mediaError.message);
  }
}